import { ErrorMessage } from 'formik'


export default function FormError({ name }) {
  return (
      <ErrorMessage name={name}>
        {(errorMessage) => (
          <p className="text-sm text-red-600 mt-2">
            {errorMessage}
          </p>
        )}
      </ErrorMessage>
  )
}